import React, { Component } from 'react';
import TableCellInput from './TableCellInput';
class TableCellPrice extends Component {
    constructor() {
        super(...arguments);
        this.input = null;
    }
    render() {
        const { renderData, form } = this.props.td;
        return (<React.Fragment>
        {renderData.map((item) => {
            return (<div key={`price_${item.dataIndex}`} style={{
                display: 'flex',
                alignItems: 'center',
                height: '35px',
            }}>
                <span>{item.title}:</span>
                <div style={{
                width: '100px',
            }}>
                  <TableCellInput td={Object.assign(Object.assign({}, item), { form })} key={`price_${item.dataIndex}`}>
                    <span>{item.rowData[item.dataIndex]}</span>
                  </TableCellInput>
                </div>
              </div>);
        })}
      </React.Fragment>);
    }
}
export default TableCellPrice;
